/**
 * Opens a Query Editor tab that a generated object script streams into.
 *
 * Shared by the Object Explorer's "Script as …" actions for object kinds whose
 * DDL has to be BUILT rather than read back from the server (Oracle packages /
 * sequences / types, SQL Server user-defined types): the tab opens immediately
 * with a placeholder comment, then the caller replaces its content once the
 * catalog reads return.
 */

import { toast } from '../../../components/ui/toaster';
import { getConnectionById } from '../../connections/utils/connectionLookup';
import { useWorkspaceStore } from '../../workspace/core/store/workspaceStore';
import { safeConnectionAlias, safeConnectionServer } from '../../../types/safeConnectionDisplay';

export function openObjectScriptTab(
  connectionId: string,
  database: string,
  objectName: string,
  script: string,
  titleSuffix: string,
  isGenerating = false,
): string {
  const { activeConnection, connection } = getConnectionById(connectionId);

  if (!activeConnection || !connection) {
    toast.error({ title: 'Error', description: 'Connection not found' });
    return '';
  }

  const { addTab, getNextQueryNumber } = useWorkspaceStore.getState();
  const queryNumber = getNextQueryNumber();

  return addTab({
    title: `${objectName}_${titleSuffix}-${queryNumber}`,
    type: 'query',
    content: {
      query: script,
      isGeneratingScript: isGenerating,
    },
    connectionInfo: {
      connectionId,
      connectionName: safeConnectionAlias(connection, 'Unnamed Connection'),
      serverHost: safeConnectionServer(activeConnection.connection),
      database,
    },
  });
}
